module.exports = __webpack_public_path__ + "img/7a_cameras.4b494425.png";